import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

interface UsersUserTokenDialogProps {
  open: boolean;
  userId: number | string | undefined;
  tokenId: number | string | undefined;
  onClose: () => void;
  onSubmit: (data: { usedAt: string; notes: string; usedFor: string }) => void;
}

const UsersUseTokenDialog: React.FC<UsersUserTokenDialogProps> = ({
  open,
  userId,
  tokenId,
  onClose,
  onSubmit,
}) => {
  const [usedAt, setUsedAt] = useState<string>(new Date().toISOString().slice(0, 16));
  const [notes, setNotes] = useState<string>('');
  const [usedFor, setUsedFor] = useState<string>('{}');

  const handleSubmit = () => {
    onSubmit({
      usedAt,
      notes,
      usedFor,
    });
    setNotes('');
    setUsedFor('{}');
    setUsedAt(new Date().toISOString().slice(0, 16));
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Use Token</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
        <TextField
          label="User ID"
          value={userId ?? ''}
          InputProps={{ readOnly: true }}
          margin="dense"
        />
        <TextField
          label="Token ID"
          value={tokenId ?? ''}
          InputProps={{ readOnly: true }}
          margin="dense"
        />
        <TextField
          label="Used At"
          type="datetime-local"
          value={usedAt}
          onChange={e => setUsedAt(e.target.value)}
          margin="dense"
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
        <TextField
          label="Notes"
          value={notes}
          onChange={e => setNotes(e.target.value)}
          margin="dense"
          fullWidth
        />
        <TextField
          label="Used For (JSON)"
          value={usedFor}
          onChange={e => setUsedFor(e.target.value)}
          margin="dense"
          fullWidth
          helperText="Enter a JSON object or array (default: {})"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>Use Token</Button>
      </DialogActions>
    </Dialog>
  );
};

export default UsersUseTokenDialog;